/**
 * Funzione che rimuove gli spazi multipli ad una stringa
 * @param {string} value
 * @returns {string}
 */
const removeMultipleSpace = (value) => (value ? value.trim().replace(/^\s+/, '').replace(/\s\s+/g, ' ') : value);

/**
 * Funzione che maiuscolizza le parole passate per visualizzarle come nomi ('paOLO roSSI' -> 'Paolo Rossi')
 * e rimuove spazi iniziali e finali
 * @param {string} value
 * @returns {string}
 */
const namecase = (value) => (value
  ? value.trim().toLowerCase().replace(/[ '-]([a-z])/g, (x) => x.toUpperCase()).replace(/^([a-z])/g, (x) => x.toUpperCase())
  : value);

export {
  removeMultipleSpace,
  namecase,
};
